export default {
  root: {
    padding: '12px 16px',
    '@media (max-width:599.95px)': {
      padding: '10px 12px'
    }
  }
};
